import { queryOptions, useQuery } from '@tanstack/react-query';
import { ResourceStatus } from '../../resources/useOcInsightsEvents';
import { SelfServiceSessionService, SessionImageDTO } from '../../generated';
import { ApiError } from '../../../components/ApiLoadingGuard/ApiLoadingGuard';

const selfServiceSessionImageKeys = {
  base: ['selfServiceSessionImage'] as const,
  one: ({ jobsiteId, sessionId, imageIndex, imageStatus }: SelfServiceImageOptionsProps) =>
    [...selfServiceSessionImageKeys.base, jobsiteId, sessionId, imageIndex, imageStatus] as const,
};

interface SelfServiceImageOptionsProps {
  jobsiteId: string | undefined;
  sessionId: string | undefined;
  imageIndex: number | null;
  imageStatus: ResourceStatus;
}

function selfServiceImageOptions({ jobsiteId, sessionId, imageIndex, imageStatus }: SelfServiceImageOptionsProps) {
  return queryOptions<SessionImageDTO, ApiError>({
    queryKey: selfServiceSessionImageKeys.one({ jobsiteId, sessionId, imageIndex, imageStatus }),
    queryFn: async () => {
      if (!jobsiteId || !sessionId || imageIndex === null)
        throw new Error('jobsiteId, sessionId and imageIndex are required');

      const response = await SelfServiceSessionService.selfServiceSessionControllerGetSessionImage({
        path: {
          jobsiteId,
          sessionId,
          index: imageIndex,
        },
      });

      if (response.data !== undefined) {
        return response.data;
      } else {
        throw (response as any).error || new Error(response.response?.statusText || 'Unknown error');
      }
    },
    enabled: !!jobsiteId && !!sessionId && imageIndex !== null && imageStatus === 'finished',
  });
}

export function useSelfServiceImage(props: SelfServiceImageOptionsProps) {
  return useQuery(selfServiceImageOptions(props));
}
